<div class="flex flex-row justify-between items-start gap-8 mt-1 mb-1">
  <rfc-title-widget [titleWidget]="defineTitleAndDescriptionWidgetObj('manage_profile')"
    class="flex-1"></rfc-title-widget>

  <mat-icon class="cursor-pointer hover:opacity-70 transition-opacity" *ngIf="!!dialogRef.id && closable"
    (click)="onClose()">close</mat-icon>
</div>

<div class="flex flex-row justify-between gap-8 mt-1 mb-1">
  <span class="highlight font-bold text-primary">{{ getCustomerRef() }}</span>
</div>

<div class="flex flex-col gap-1 mt-1 mb-1">
  <span class="font-normal text-sm text-gray-600">{{ "choose_profile_label" | i18n }}</span>
  <span class="font-normal text-sm text-gray-600">{{ "choose_role_label" | i18n }}</span>
</div>

<div class="flex flex-col md:flex-row justify-around items-center gap-4 mt-1 mb-1">
  <mat-form-field class="w-full md:w-[35%]">
    <mat-select *ngIf="profiles.length > 1" placeholder="{{ 'customer' | i18n }}"
      (selectionChange)="changeCustomerSelected($event)">
      <mat-option *ngFor="let profileSelected of profiles" [value]="profileSelected">
        {{ getCustomerName(profileSelected) }}
      </mat-option>
    </mat-select>

    <input *ngIf="profiles.length === 1" matInput [value]="profileSelected" disabled="true" />
  </mat-form-field>

  <mat-form-field class="w-full md:w-[30%]">
    <mat-select placeholder="{{ 'role' | i18n }}" (selectionChange)="changeRoleSelected($event)"
      [(ngModel)]="roleSelected">
      <mat-option *ngFor="let role of roles" [value]="role">
        {{ role.roleName }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="flex flex-col-reverse md:flex-row justify-center items-center gap-8 mt-1 mb-1">
  <button *ngIf="!!!closable" mat-raised-button (click)="onLogout()" class="ald-mat-button w-full md:w-auto">
    {{ "logout" | i18n }}
  </button>

  <button mat-raised-button (click)="onSubmit()" [disabled]="!!!roleSelected"
    class="ald-mat-button primary w-full md:w-auto px-10">
    {{ "confirm" | i18n }}
  </button>
</div>